import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BaseUrl } from "../../config";
import { Banner } from '../../components';
import { Loader } from '../../components';
import {JobsList} from '../../components'
import {HeroText} from '../../components'

const CareersContainer = (props) => {
  const [arrayJobs, setArrayJobs] = useState([])
  const [isFetching, setisFetching] = useState(true)

  
  useEffect(() => {
    document.title = "Careers Invrsion"
    // all jobs
    fetch(`${BaseUrl}/jobs?key=invrsion`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      setArrayJobs(json.data.careers);
      setisFetching(false)
    })
    
  }, []);


  const heroImg = require('../../assets/careers-hero.jpg');

  const arrayLoad = [
    heroImg
  ]

  return (
    <React.Fragment>
      <HeroText 
        title="Work at Invrsion, make the most of your reality" 
        paragraph="Not fulfilled with your current job? Experience what it’s like to work with Full Reality."
        textBelow={false} 
        image={heroImg}
        alignBg="top center"
      />
      <div className="center--paragraph">
        <p className="preset-13 intro-title">OUR MISSION</p>
        <h6 className="md--title">We’re on a mission to use technology for good to great; to improve every industry and change reality along the way.</h6>
      </div>
      <div className="side--quote-wrap extra--margin">
        <h6 className="md--title side--title">Our values</h6>
        <div className="side--text">
          <p className="preset-9">
          These are the values that guide each of us at Invrsion on our mission to make Full Reality a reality.
          </p>
        </div>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">People before technology</h6>
        <p className="preset-9 side--text">
        Although we’re a tech company, we believe the most in people. That’s why we work hard to improve the daily lives of our employees, clients, and all humankind with our solutions.
        </p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Passion for perfection</h6>
        <p className="preset-9 side--text">
        What we do is an artform, but it takes a lot of work to make sure all the details are accurately represented. That’s why our passion is what allows us to create the perfect results.
        </p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Complexity made simple</h6>
        <p className="preset-9 side--text">
        We work with very complex technologies, but have to express them easily to our clients. That’s why we make sure we make things simple for an enjoyable customer experience.
        </p>
      </div>
      <div className="center--paragraph">
        <img className="quote-icon" src={require('../../assets/quote-icon.svg')} />
        <h6 className="md--title">I have been impressed with the urgency of doing. Knowing is not enough; we must apply. Being willing is not enough;<br />we must do.</h6>
        <p className="preset-10 quote-author">Leonardo Da Vinci</p>
      </div>
      {
        !isFetching &&
        <JobsList jobs={arrayJobs} />
      }
      <Banner 
        text="Didn’t find your perfect match? We are always open to new ideas" 
        route="mailto:invrsion@invrsion.com?subject=Spontaneous Application" 
        copyRoute="Reach out"
        isDownload={true} isExternal={true}
        />
      <Loader isFetching={isFetching}  arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default CareersContainer;
